<template>
  <div>
  <div class="room-type__item">
    <div class="room-type__top">
      <div class="room-type-left">
        1 Kişilik Oda
      </div>
      <div class="room-type-right">
        <p class="room-type__price">290 TL <span>x dönem </span></p>
        <p class="room-type__price">90 TL <span>x gün </span></p>
        <div class="room-type-icons">
          <span class="icon-update" @click="updateRoom">
            <svg-icon type="icon-update"/>
          </span>
          <span class="icon-delete">
            <svg-icon type="icon-delete"/>
          </span>
        </div>
      </div>
    </div>
    <div class="room-type__top">
      <div class="room-type-left">
        2 Kişilik Oda
      </div>
      <div class="room-type-right">
        <p class="room-type__price">290 TL <span>x dönem </span></p>
        <p class="room-type__price">90 TL <span>x gün </span></p>
        <div class="room-type-icons">
          <span class="icon-update" @click="updateRoom">
            <svg-icon type="icon-update"/>
          </span>
          <span class="icon-delete">
            <svg-icon type="icon-delete"/>
          </span>
        </div>
      </div>
    </div>
    <div class="room-type__top">
      <div class="room-type-left">
        3 Kişilik Oda
      </div>
      <div class="room-type-right">
        <p class="room-type__price">290 TL <span>x dönem </span></p>
        <p class="room-type__price">90 TL <span>x gün </span></p>
        <div class="room-type-icons">
          <span class="icon-update" @click="updateRoom">
            <svg-icon type="icon-update"/>
          </span>
          <span class="icon-delete">
            <svg-icon type="icon-delete"/>
          </span>
        </div>
      </div>
    </div>
    <div class="room-type__top">
      <div class="room-type-left">
        4 Kişilik Oda
      </div>
      <div class="room-type-right">
        <p class="room-type__price">290 TL <span>x dönem </span></p>
        <p class="room-type__price">90 TL <span>x gün </span></p>
        <div class="room-type-icons">
          <span class="icon-update" @click="updateRoom">
            <svg-icon type="icon-update"/>
          </span>
          <span class="icon-delete">
            <svg-icon type="icon-delete"/>
          </span>
        </div>
      </div>
    </div>       
    <transition name="fade">
      <div class="register-box__info col-xl-12 room-update" v-show="show">
        <div class="groups">
          <v-select :options="genders" placeholder="Yurt Tipi Adı" style="font-weight: bold"/>
          <v-select :options="days1" placeholder="Günlük Fiyat" style="font-weight: bold"/>
          <v-select :options="days2" placeholder="Dönemlik Fiyat" style="font-weight: bold"/>
        </div>

        <div class="room-update__gallery">
          <MyDormGaleriThumb/>
        </div>
        <div class="room-update__choose">
          <h1 class="room-update__title">ODA ÖZELLİKLERİNİ SEÇİN</h1>
          <div class="choose-wrp">
            <div class="dorm-inf__item"
                 :class="n % 2 ? 'active' : 'disable'"
                 v-for="n in oda" :key="n">
            <span class="dorm-inf__icon">
                 <svg-icon type="icon-fridge"/>
            </span>
              <span class="dorm-inf__title">{{n.label}}</span>
            </div>
          </div>
          <button class="submit">KAYDET</button>
        </div>
      </div>
    </transition>
  </div>
  </div>
</template>

<script>
import MyDormGaleriThumb from '@/components/MyDormGalleryThumb'
import SelectBox from '@/components/SelectBox'

export default {
  name: 'MyDormRoomType',
  components: {
    MyDormGaleriThumb, SelectBox
  },
  data () {
    return {
      genders: [
        { id: 1, name: "Erkek Öğrenci Yurdu" },
        { id: 2, name: "Kız Öğrenci Yurdu" },
        ],
      oda: [
        {
          label: 'Balkonlu Oda',
          value: '01',
          selected: false
        },
        {
          label: 'Mini Buzdolabı',
          value: '02',
          selected: false
        },
        {
          label: 'Asansör',
          value: '03',
          selected: false
        },
        {
          label: 'Klima',
          value: '04',
          selected: false
        },
        {
          label: 'Duş ve Wc',
          value: '04',
          selected: false
        },
        {
          label: 'TV ve Uydu Yayını',
          value: '04',
          selected: false
        },
        {
          label: 'Sınırsız İnternet',
          value: '05',
          selected: false
        },
        {
          label: 'Kişisel Dolap',
          value: '04',
          selected: false
        },
        {
          label: 'Çalışma Masası',
          value: '05',
          selected: false
        },
        {
          label: 'Oda Telefonu',
          value: '05',
          selected: false
        }             
      ],            
      show: false,
      days: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days1: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days2: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ]
    }
  },
  methods: {
    updateRoom () {
      if (this.show === true) { this.show = false } else {
        this.show = true
      }
    }
  }
}
</script>

<style scoped>

</style>
